import React from "react";

const HoTrafficSign = ({ size = 24, color = "currentColor", ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Speed limit sign" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {/* Outer ring */}
      <circle cx="12" cy="12" r="9" />
      {/* Inner ring (subtle) */}
      <circle cx="12" cy="12" r="7" opacity="0.35" />
      {/* Number: 50 (stylized) */}
      <path d="M9 9.25H7.25V11H9c.7 0 1.25.55 1.25 1.25S9.7 13.5 9 13.5H7.25" />
      <path d="M16.75 10.75c0-1-.75-1.75-1.75-1.75s-1.75.75-1.75 1.75v2.5c0 1 .75 1.75 1.75 1.75s1.75-.75 1.75-1.75v-2.5z" />
    </g>
  </svg>
);

export default HoTrafficSign;
